
<div class="card" *ngIf="!!data">
    <div class="card-body" style="background-color: #EEEEEE;" *ngIf="loadingState == 'done'">
        <h5 class="card-title">ORDRESTYRING {{ 'Standard.CaseERPSettings' | translate }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'Standard.CaseERPSettingsSubText' | translate }}</h6>
        <!-- Responsible -->
        <div class="dataItem" *ngIf="!!companyUsers && companyUsers.length > 0">
            <label class="dataItem-label">{{ 'Standard.Responsible' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.responsibleId" (change)="updateParent()">
                <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                <option *ngFor="let x of companyUsers" [value]="x.userId">{{ x.name }}</option>
            </select>
        </div>
        <!-- Foreman -->
        <div class="dataItem" *ngIf="!!companyUsers && companyUsers.length > 0">
            <label class="dataItem-label">{{ 'Standard.Foreman' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.foremanId" (change)="updateParent()">
                <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                <option *ngFor="let x of companyUsers" [value]="x.userId">{{ x.name }}</option>
            </select>
        </div>
        <!-- OS Status -->
        <div class="dataItem" *ngIf="!!osStatuses && osStatuses.length > 0">
            <label class="dataItem-label">OS {{ 'Standard.Status' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.osStatus" (change)="updateParent()">
                <option *ngFor="let x of osStatuses" [ngValue]="x.id">{{ x.text }}</option>
            </select>
        </div>
        <!-- Case Type -->
        <div class="dataItem" *ngIf="!!osTypes && osTypes.length > 0">
            <label class="dataItem-label">{{ 'Standard.CaseType' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" id="caseType" [(ngModel)]="data.caseTypeId" (change)="updateParent()">
                <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                <option *ngFor="let x of osTypes" [ngValue]="x.id">{{ x.text }}</option>
            </select>
        </div>
        <!-- Department -->
        <div class="dataItem" *ngIf="!!osDepartments && osDepartments.length > 0">
            <label class="dataItem-label">{{ 'Standard.Department' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.osDepartmentId" (change)="updateParent()">
                <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                <option *ngFor="let x of osDepartments" [ngValue]="x.id">{{ x.text }}</option>
            </select>
        </div>
        <!-- Customer Type -->
        <div class="dataItem" *ngIf="!!osCustomerGroups && osCustomerGroups.length > 0">
            <label class="dataItem-label">{{ 'Standard.CustomerType' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.customerGroupId" (change)="updateParent()">
                <option *ngFor="let x of osCustomerGroups" [ngValue]="x.id">{{ x.text }}</option>
            </select>
        </div>
        <!-- Debtor Group -->
        <div class="dataItem" *ngIf="!!osEconomyGroups && osEconomyGroups.length > 0">
            <label class="dataItem-label">{{ 'Standard.DebtorGroup' | translate }}</label>
            <select class="form-control form-control-sm form-control-erp" [disabled]="!!osEconomyGroups && osEconomyGroups.length == 0" [(ngModel)]="data.economySystemGroupId" (change)="updateParent()">
                <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                <option *ngFor="let x of osEconomyGroups" [ngValue]="x.number">{{ x.name }}</option>
            </select>
        </div>
    </div>
    <div class="card-body mt-3 mb-3 text-center" *ngIf="loadingState != 'done'">
        {{ 'Standard.Loading' | translate }}...
        <button class="btn btn-primary m-auto mt-4" (click)="getTypes()" *ngIf="loadingState == 'error'">Hent OS data igen</button>
    </div>
</div>